import { getWidgetDefaultProps } from "Utils/widgetConfiguration"

import { v4 as uuid } from "uuid"

import { isObjectV2 } from "Utils/global.js"

export const getNewPageAfterMovingFromLayout = (page, movingConfig) => {
  var pageToReturn = JSON.parse(JSON.stringify(page))
  var layoutBreakPoints = ["lg", "md", "sm"]
  if (page?.useFixedBloc === undefined) pageToReturn.useFixedBloc = false
  if (page?.fixedLayouts === undefined) pageToReturn.fixedLayouts = { lg: [], md: [], sm: [] }
  if (page?.fixedLayoutsHeight === undefined) pageToReturn.fixedLayoutsHeight = 100

  var destinationIsFixedLayout = movingConfig.destination === "fixedLayout"
  var initialLayoutPropertyName = destinationIsFixedLayout ? "layouts" : "fixedLayouts"
  var destinationLayoutPropertyName = destinationIsFixedLayout ? "fixedLayouts" : "layouts"

  layoutBreakPoints.forEach(breakpoint => {
    let widgetLayout
    if (Array.isArray(pageToReturn?.[initialLayoutPropertyName]?.[breakpoint])) {
      widgetLayout = pageToReturn[initialLayoutPropertyName][breakpoint].find(
        widgetObj => widgetObj.i === movingConfig.widgetId
      )
    }
    if (widgetLayout) {
      if (destinationIsFixedLayout) pageToReturn.useFixedBloc = true

      //initial layout
      let filteredInitialLayout = pageToReturn[initialLayoutPropertyName][breakpoint].filter(
        widgetObj => widgetObj.i !== movingConfig.widgetId
      )
      pageToReturn[initialLayoutPropertyName][breakpoint] = filteredInitialLayout

      //destination layout
      let previousElementOfLayout = pageToReturn[destinationLayoutPropertyName][breakpoint]
      pageToReturn[destinationLayoutPropertyName][breakpoint] = [
        ...previousElementOfLayout,
        { ...widgetLayout, x: 0, y: 0 },
      ]
    }
  })
  return pageToReturn
}

export const getFolderFromPageId = (folders, pageId) => {
  if (!Array.isArray(folders)) return undefined
  const originFolder = folders.find(folder => {
    if (!Array.isArray(folder?.pageList)) return false
    return folder.pageList.includes(pageId)
  })
  return originFolder
}

export const generateDictioTemporary_NewId = createdWidgets => {
  const dictioTemporary_NewId = {}
  createdWidgets.forEach(widget => {
    if (widget?.temporaryId && widget?._id?.$oid) {
      dictioTemporary_NewId[widget.temporaryId] = widget._id.$oid
    }
  })
  return dictioTemporary_NewId
}

export const getLayoutsAfterTemporaryIdReplacement = (initialLayouts, dictioTemp_NewId) => {
  var layoutsAfterReplacement = {}
  var temporyIdList = Object.keys(dictioTemp_NewId)
  var breakpoints = Object.keys(initialLayouts)
  breakpoints.forEach(breakpoint => {
    layoutsAfterReplacement[breakpoint] = initialLayouts[breakpoint].map(primitiveLayout => {
      if (temporyIdList.includes(primitiveLayout.i)) {
        return {
          ...primitiveLayout,
          i: dictioTemp_NewId[primitiveLayout.i],
        }
      }
      return primitiveLayout
    })
  })
  return layoutsAfterReplacement
}

export const getLayoutsAfterWidgetRemoval = (initialLayouts, widgetIdToDelete) => {
  if (initialLayouts === undefined) return { lg: [], md: [], sm: [] }

  var newLayouts = JSON.parse(JSON.stringify(initialLayouts))
  if (widgetIdToDelete === undefined) return newLayouts

  var breakpoints = Object.keys(newLayouts)
  breakpoints.forEach(breakpoint => {
    var widgetLayoutIndex = newLayouts[breakpoint].findIndex(
      layout => layout.i === widgetIdToDelete
    )
    if (widgetLayoutIndex >= 0) newLayouts[breakpoint].splice(widgetLayoutIndex, 1)
  })
  return newLayouts
}

export const getLayoutsAfterWidgetDuplication = (
  initialLayouts,
  { widgetIdToDuplicate, newWidgetTempId, widgetCategory }
) => {
  var newLayouts = JSON.parse(JSON.stringify(initialLayouts))
  let breakpoints = Object.keys(newLayouts)

  breakpoints.forEach(breakpoint => {
    var layoutFound = newLayouts[breakpoint].find(item => item.i === widgetIdToDuplicate)
    if (layoutFound) {
      newLayouts[breakpoint] = [
        ...newLayouts[breakpoint],
        {
          ...layoutFound,
          i: newWidgetTempId,
          x: 0,
          y: widgetCategory === "filter" ? -1000 : 1000,
        },
      ]
    }
  })
  return newLayouts
}

export const getNewPageAfterFixBlocResize = (oldPage, breakpoint, fixedLayoutsHeight) => {
  var defaultFixedLayoutHeight = {
    sm: 100,
    md: 100,
    lg: 100,
  }
  // Copie : modifier l'objet de la page précédente modifiait aussi la version enregistrée (référence
  // de « non sauvegardé » et du panneau Modifications).
  var layoutToSet = { ...(oldPage.fixedLayoutsHeightByBreakPoint || defaultFixedLayoutHeight) }
  if (["lg", "md"].includes(breakpoint)) {
    layoutToSet["lg"] = fixedLayoutsHeight
    layoutToSet["md"] = fixedLayoutsHeight
  } else if (breakpoint === "sm") layoutToSet[breakpoint] = fixedLayoutsHeight

  return {
    ...oldPage,
    fixedLayoutsHeightByBreakPoint: layoutToSet,
  }
}

export const newWidgetConstructor = (widgetSpecification, languageID, options) => {
  var title = "My beautiful widget"
  if (widgetSpecification.category === "filter" || widgetSpecification.category === "text")
    title = ""

  const widgetType = widgetSpecification.type
  const defaultWidgetProps = getWidgetDefaultProps(widgetType, languageID, options)
  const isImage = widgetType === "image"
  const isMultiTabWidget = widgetType === "multiTabWidget"

  var temporaryId = uuid()
  return {
    _id: {
      $oid: temporaryId, //real oid will be created
    },
    isTemporaryWidget: true,
    title: title,
    temporaryId: temporaryId,
    widgetCategory: widgetSpecification.category,
    widgetType: widgetType,
    chartType: widgetType, //deprecated
    data: [],
    category: {},
    groupBy: [],
    conditions: {},
    canBeCompared: true,
    widgetProps: { ...defaultWidgetProps },
    ...(isImage && { temporaryImageId: "" }),
    ...(isMultiTabWidget && { tabsInfos: { tabsList: [] } }),
  }
}

export const findWidgetIndexById = (widgetList, widgetId) => {
  if (widgetList === undefined || widgetId === undefined) {
    return -1
  }
  return widgetList.findIndex(widget => {
    return widget._id.$oid === widgetId
  })
}

export const getNewWidgetListOnMultiTabSave = (finalEditedWidget, widgetList, options) => {
  var widgetListToReturn = [...widgetList]
  var isMultiTabWidget = finalEditedWidget.widgetType === "multiTabWidget"

  if (
    isMultiTabWidget &&
    Array.isArray(options?.multiTabWidgetsList) &&
    options.multiTabWidgetsList.length > 0
  ) {
    options.multiTabWidgetsList.forEach(widget => {
      var indexFound = findWidgetIndexById(widgetListToReturn, widget._id.$oid)
      if (indexFound !== -1) {
        widgetListToReturn.splice(indexFound, 1, widget)
      }
    })
  }
  return widgetListToReturn
}

export const getNewWidgetListAfterSavingInDB = (widgets, dictionaryTempIdNewId) => {
  var temporaryIdArray = Object.keys(dictionaryTempIdNewId)

  var newWidgets = widgets.map(widget => {
    var actualWidgetId = widget._id.$oid
    if (temporaryIdArray.includes(actualWidgetId)) {
      var { temporaryId, _id, ...widgetToReturn } = widget
      var newId = dictionaryTempIdNewId[actualWidgetId]
      var isMultiTabWidget = widget.widgetType === "multiTabWidget"
      var newTabsInfos = {}

      if (isMultiTabWidget && widget?.tabsInfos !== undefined) {
        newTabsInfos = getNewTabsInfosOnSaveInDB(widget.tabsInfos, dictionaryTempIdNewId)
      }
      var newWidget = {
        ...widgetToReturn,
        _id: {
          $oid: newId,
        },
        isTemporaryWidget: false,
        ...(isMultiTabWidget && { tabsInfos: newTabsInfos }),
      }
      return newWidget
    }

    return widget
  })
  return newWidgets
}

export const getNewTabsInfosOnSaveInDB = (tabsInfos, dictionaryTempIdNewId) => {
  var temporaryIdArray = Object.keys(dictionaryTempIdNewId)
  var newTabsList = tabsInfos.tabsList.map(tabElt => {
    var newTabWidgetId = tabElt.widgetId
    if (temporaryIdArray.includes(tabElt.widgetId)) {
      newTabWidgetId = dictionaryTempIdNewId[tabElt.widgetId]
    }
    return {
      ...tabElt,
      widgetId: newTabWidgetId,
    }
  })
  return {
    ...tabsInfos,
    tabsList: newTabsList,
  }
}

export const transformWidget = (baseWidget, newDataWidget) => {
  var { _id, pageId, temporaryId, ...updateToApply } = newDataWidget
  var finalEditedWidget = {
    ...baseWidget,
    ...updateToApply,
  }
  return finalEditedWidget
}

export const getSubWidgetsIdsFromMultiTabWidget = multiTabWidget => {
  var tabsList = multiTabWidget?.tabsInfos?.tabsList
  if (Array.isArray(tabsList)) return tabsList.map(tab => tab.widgetId)
  return []
}

export const getSubWidgetsRefFromMultiTabWidget = multiTabWidget => {
  var tabsList = multiTabWidget?.tabsInfos?.tabsList
  if (Array.isArray(tabsList)) return tabsList.map(tab => tab.widgetReference)
  return []
}

export const getNewDuplicatedWidget = (previousWidget, partialTrad, tempId) => {
  // Create duplicate of widgetToDuplicate, change _id & temporaryId by a new uuid()
  const { COPY = "Copy" } = partialTrad
  const newWidget = {
    ...previousWidget,
    _id: { $oid: tempId },
    temporaryId: tempId,
    isTemporaryWidget: true,
    title: previousWidget?.title !== "" ? `${previousWidget?.title} - ${COPY}` : "",
  }
  return newWidget
}

export const getWidgetsToAddOnDuplicate = (
  workingWidget,
  actualWidgetDuplicated = {},
  tempId,
  partialTrad
) => {
  if (!Array.isArray(workingWidget)) return []

  if (!isObjectV2(actualWidgetDuplicated) || Object.keys(actualWidgetDuplicated).length === 0) {
    return []
  }

  var newWidget = getNewDuplicatedWidget(actualWidgetDuplicated, partialTrad, tempId)

  var newWidgetsList = []

  if (actualWidgetDuplicated.widgetType === "multiTabWidget") {
    var subWidgetsRef = getSubWidgetsRefFromMultiTabWidget(actualWidgetDuplicated)

    subWidgetsRef.forEach(widgetRef => {
      var widgetFound = workingWidget.find(widget => widget?.multiTabReference === widgetRef)
      if (widgetFound) {
        var newWidgetId = uuid()
        var newMultiTabRef = uuid()
        newWidgetsList.push({
          ...widgetFound,
          _id: { $oid: newWidgetId },
          multiTabReference: newMultiTabRef,
        })
        newWidget = {
          ...newWidget,
          tabsInfos: {
            ...newWidget.tabsInfos,
            tabsList: newWidget.tabsInfos.tabsList.map(tab => {
              if (tab.widgetReference === widgetRef) {
                return {
                  ...tab,
                  widgetId: newWidgetId,
                  widgetReference: newMultiTabRef,
                }
              }
              return { ...tab }
            }),
          },
        }
      }
    })
  }

  newWidgetsList.push(newWidget)

  return newWidgetsList
}

export const getNewStateOnFilterValueSelection = (pageState, payload) => {
  var previousValueFilter = pageState?.actualPage?.valueFilterSelected
  var payloadToUse = payload
  if (!Array.isArray(payload)) {
    payloadToUse = [payload]
  }
  return {
    ...pageState,
    actualPage: {
      ...pageState.actualPage,
      valueFilterSelected: getNewValueFilterSelected(previousValueFilter, payloadToUse),
    },
  }
}

export const getNewValueFilterSelected = (previousValueFilter = {}, newValuesList = []) => {
  var newValueFilter = { ...previousValueFilter }
  newValuesList.forEach(newValueObj => {
    let { id, ...restOfPayload } = newValueObj
    newValueFilter[id] = { ...restOfPayload }
  })
  return newValueFilter
}

export const getInitialPageFilter = widgets => {
  var initialPageFilter = []
  widgets.forEach(widget => {
    if (widget.widgetType === "dropdownList" && widget.defaultValues) {
      var fieldUUID = ""
      if (Array.isArray(widget.data) && widget.data.length > 0) {
        fieldUUID = widget.data[0].uuid
      }
      initialPageFilter.push({
        id: widget._id.$oid,
        value: widget.defaultValues,
        fieldUUID: fieldUUID,
        operation: "==",
      })
    }
  })
  return initialPageFilter
}

export const getNewStateOnWidgetDataSuccess = (previousState, payload) => {
  // console.log("--->")
  // console.log("getNewStateOnWidgetDataSuccess payload:", payload)
  // console.log("previousState:", previousState)
  var { widgetId, ...payloadToAdd } = payload
  var { requestDate } = payloadToAdd
  var previousWidgetData = previousState?.actualPage?.widgetsData?.[widgetId]

  if (!newWidgetDataShouldOverideThePreviousOne(requestDate, previousWidgetData)) {
    return { ...previousState }
  }

  return {
    ...previousState,
    actualPage: {
      ...previousState.actualPage,
      widgetsData: {
        ...previousState.actualPage.widgetsData,
        [widgetId]: payloadToAdd,
      },
    },
  }
}

export const date1IsMoreRecentThantDate2 = (date1, date2) => {
  return date1.localeCompare(date2) === 1
}

export const newWidgetDataShouldOverideThePreviousOne = (date, previousWidgetDate) => {
  const noDataInStore = previousWidgetDate === undefined
  const noRequestDateInStore = [null, undefined, ""].includes(previousWidgetDate?.requestDate)
  const noDateInLastDataRequest = [null, undefined, ""].includes(date)
  if (noDataInStore || noRequestDateInStore || noDateInLastDataRequest) return true
  var actualRequestDate = previousWidgetDate.requestDate
  return date1IsMoreRecentThantDate2(date, actualRequestDate)
}

export const getNewUploadNumberFromThumbnailConfig = (thumbnailConfig = {}) => {
  let previousUplaodNumber = thumbnailConfig?.thumbnailUpload
  const isUndefined = previousUplaodNumber === undefined
  const isNotNumber = typeof previousUplaodNumber !== "number"
  if (isUndefined || isNotNumber) previousUplaodNumber = 0
  return previousUplaodNumber + 1
}

export const getNewUploadNumberFromPage = page => {
  const thumbnailConfig = page?.thumbnailConfig || {}
  return getNewUploadNumberFromThumbnailConfig(thumbnailConfig)
}

/**
 * Disposition corrigée par la grille ELLE-MÊME (pas un glisser / redimensionner de l'utilisateur) :
 * largeurs ramenées aux colonnes du palier, tassement. Les dispositions écrites par l'agent ou un
 * modèle reprennent `lg` en `md` / `sm` (12 colonnes de large pour 6, puis 1) : la grille les corrige
 * dès l'entrée en édition. Sur une page sans changement en cours, la correction devient la nouvelle
 * référence (sinon « modifications non sauvegardées » sans rien avoir touché) ; sur une page déjà
 * modifiée, elle s'ajoute aux changements comme avant.
 *
 * Une correction ne fait que déplacer / redimensionner : une disposition qui désigne un widget que la
 * page n'a pas (ni dans ses widgets, ni dans sa disposition) est celle d'une AUTRE page — la grille
 * la renvoie quand la page change sous elle — et elle est ignorée.
 */
export const getPagesAfterLayoutNormalization = (page, initialPage, layoutProperty, layouts, widgetIds = []) => {
  const known = new Set(widgetIds)
  Object.values(page?.[layoutProperty] || {}).forEach(items => (items || []).forEach(item => known.add(item?.i)))
  const foreign = Object.values(layouts || {}).some(items => (items || []).some(item => !known.has(item?.i)))
  if (foreign) return { page, initialPage }
  const nextPage = { ...page, [layoutProperty]: layouts }
  return { page: nextPage, initialPage: page === initialPage ? nextPage : initialPage }
}
